import "./Topbar.css";

function Topbar() {
  return (
    <div className="probioma-topbar">
       🚚 Free Delivery in Tirana | 
      <a href="tel:+355697607650"> +355 69 760 7650</a> | 
      <a href="mailto:info@probioma.al"> info@probioma.al</a>
    </div>
  );
}

export default Topbar;
